import type { ReactNode } from "react";
import { Progress, Spin } from "../../../../../../../../shared/frontend/ui";
import "../personOverview.css";

export type OverviewKpiTone = "ok" | "warn" | "error" | "neutral";

/**
 * Eine Kennzahl der Personenübersicht — die eine Schriftskala aller Blöcke: Beschriftung, Wert, höchstens eine
 * Zusatzzeile; Zahlen und Wörter in derselben Größe. Farbe nur bei Abweichung (`tone`). `progress` zeichnet
 * unter dem Wert einen Balken (z. B. vergangene Laufzeit).
 */
export function OverviewKpi({ label, children, sub, tone = "neutral", progress, progressLabel, refreshing = false }: {
  label: ReactNode;
  children: ReactNode;
  sub?: ReactNode;
  tone?: OverviewKpiTone;
  progress?: number;
  progressLabel?: string;
  refreshing?: boolean;
}) {
  return (
    <div className="person-overview-kpi" data-tone={tone}>
      <span className="person-overview-kpi-label">{label}</span>
      <span className="person-overview-kpi-value" aria-busy={refreshing || undefined}>
        {refreshing ? <span className="person-overview-kpi-refresh"><Spin inline /></span> : children}
      </span>
      {progress != null ? <Progress showInfo={false} percent={progress} aria-label={progressLabel} /> : null}
      {sub ? <span className="person-overview-kpi-sub">{sub}</span> : null}
    </div>
  );
}
